import styled from "@emotion/styled";

export const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-normal);
  background: ${(props) =>
    props.disabled
      ? "var(--alias-color-background-normal-alternative)"
      : "var(--alias-color-background-normal-normal)"};
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

export const LeftSection = styled.div`
  display: flex;
  width: 160px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

export const VerticalLine = styled.div`
  width: 1px;
  height: 100%;
  background: var(--alias-color-line-normal);
`;

export const RightSection = styled.div`
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

export const SummaryDataRowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  justify-content: space-between;
`;
